import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

import img1 from "../../../assets/EMP_Retails/RetailsTestimonials/puma-retail-image-1.webp";

import img2 from "../../../assets/EMP_Retails/RetailsTestimonials/pet-paradise-retail-image-1.webp";

import img3 from "../../../assets/EMP_Retails/RetailsTestimonials/comoto-retail-image.webp";

import img4 from "../../../assets/EMP_Retails/RetailsTestimonials/taylor-retail-image-1.webp";

import logo1 from "../../../assets/EMP_Retails/RetailsTestimonials/puma-logo.webp";

import logo2 from "../../../assets/EMP_Retails/RetailsTestimonials/pet-paradise-logo.webp";
import logo3 from "../../../assets/EMP_Retails/RetailsTestimonials/comoto-logo.webp";

import logo4 from "../../../assets/EMP_Retails/RetailsTestimonials/leevers-logo.webp";

export default function HealthcareTestimonials() {

  const testimonials = [
    {
      image: img1,
      logo: logo1,
      quote:
        "Our business involves humans taking care of humans, and robots will never be able to do that... By reducing some of their financial worries, we also helped them to stress less and become more engaged.",
      name: "Cindy Eisenmenger",
      role: "VP of Cash Disbursements, BrightSpring Health Services",
    },

    {
      image: img2,
      logo: logo2,
      quote:
        "I would absolutely recommend DailyPay for other healthcare service providers looking to take the next step in competitive employment offerings while also looking to incentivize increased adoption of internal processes like EW.",
      name: "Alex Litman",
      role: "President & CEO, Ideal Home Health",
    },

    {
      image: img3,
      logo: logo3,
      quote:
        "We try to provide our employees with flexibility and options when it comes to benefits, and we certainly view On-Demand Pay as an important benefit.",
      name: "Jason Tjosvold",
      role: "Chief Administrative Officer, Mary T. Inc",
    },

    {
      image: img4,
      logo: logo4,
      quote:
        "With this competitor’s solution, we had much lower adoption rates than we’d had with DailyPay originally.",
      name: "Yarianny Rodriguez",
      role: "Director of Payroll, Ultimate Care",
    },
  ];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    if (current < testimonials.length - 1) {
      setCurrent(current + 1);
    }
  };

  const prevSlide = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };

  return (
    <section className="w-full bg-white py-20 overflow-hidden">

      {/* HEADING */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <h2
          className="
            text-[48px]
            lg:text-[42px]
            font-thin
            leading-[1.1]
            text-[#2b0000]
            max-w-[900px]
            tracking-tighter
            mb-0
          "
        >
Here’s What Leading Retailers Say<br /> 
 <span className="lg:ml-[90px]">  About DailyPay</span>        
 </h2>

      </div>

      {/* SLIDER */}
      <div className="max-w-7xl mx-auto mt-12 relative px-6 lg:px-12">

        {/* LEFT BUTTON */}
        {current > 0 && (
          <button
            onClick={prevSlide}
            className="
              absolute
              left-0
              lg:-left-3
              top-1/3
              -translate-y-1/2
              z-20
              w-10
              h-10
              rounded-full
              bg-white
              border
              shadow-md
              flex
              items-center
              justify-center
              hover:bg-[#2b0000]
              hover:text-white
              transition
            "
          >
            <ChevronLeft size={34} />
          </button>
        )}

        {/* RIGHT BUTTON */}
        {current < testimonials.length - 1 && (
          <button
            onClick={nextSlide}
            className="
              absolute
              right-0
              top-1/3
              -translate-y-1/2
              z-20
              w-10
              h-10
              rounded-full
              bg-white
              border
              shadow-md
              flex
              items-center
              justify-center
              hover:bg-[#2b0000]
              hover:text-white
              transition
            "
          >
            <ChevronRight size={34} />
          </button>
        )}

        {/* CONTENT */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* LEFT IMAGE */}
          <div>

            <img
              src={testimonials[current].image}
              alt=""
              className="
                w-full
                lg:w-[470px]
                h-[420px]
                lg:h-[370px]

                object-cover
                rounded-[36px]
                -ml-[40px]
              "
            />

          </div>

          {/* RIGHT CONTENT */}
          <div
  className="
    relative
    w-full
    lg:w-[700px]
    min-h-[300px]
    lg:-ml-[80px]
  "
>

  {/* TOP LINE */}
  <div className="absolute top-7 left-0 w-full h-[1px] bg-[#d6d6d6]" />

  {/* QUOTE ICON */}
  <div
    className="
      relative
      ml-[30px]
      z-10
      w-16
      h-16
      rounded-full
      bg-[#e9efff]
      flex
      items-center
      justify-center
    "
  >
    <Quote size={34} className="text-[#2347a4]" />
  </div>

  {/* CONTENT */}
  <div className="pl-[30px] pr-[20px]">

    {/* QUOTE TEXT */}
    <p
      className="
        mt-10
        text-[24px]
        lg:text-[20px]
        leading-[1.5]
        font-bold
        text-[#1b0d0d]
        max-w-[920px]
      "
    >
      “{testimonials[current].quote}”
    </p>

    {/* NAME */}
    <h3 className="mt-8 text-[20px] font-bold text-black">
      {testimonials[current].name}
    </h3>

    {/* ROLE */}
    <p className="text-[18px] text-[#2b0000]">
      {testimonials[current].role}
    </p>

    {/* LOGO */}
    <img
      src={testimonials[current].logo}
      alt=""
      className="mt-2 h-[60px] object-contain"
    />

  </div>

  {/* BOTTOM LINE */}
  <div className="absolute -bottom-8 left-0 w-full h-[1px] bg-[#d6d6d6]" />
  

</div>
{/* DOTS */}
<div className="flex justify-end items-center gap-3 mt-8 relative z-30">

  {testimonials.map((_, index) => (
    <div
      key={index}
      className={`
        w-3
        h-3
        rounded-full
        transition-all
        duration-300
        ${
          current === index
            ? "bg-black scale-110"
            : "bg-[#cfcfcf]"
        }
      `}
    />
  ))}

</div>
</div>
</div>
    </section>
  );
}